/**
 * Privacidad del Session Replay de Sentry.
 *
 * En producción las pantallas del back-office muestran datos personales de clientes (nombres,
 * DPI, teléfonos, montos) y Sentry es un tercero: el replay va con TODO el texto enmascarado y los
 * medios bloqueados. En staging y desarrollo hay sólo datos de prueba, y verlos sin máscara hace
 * que el replay sirva para depurar.
 *
 * Es una función pura, separada de `instrument.ts`, para poder probar la decisión sin levantar el SDK.
 */
export type ReplayPrivacy = {
  maskAllText: boolean
  blockAllMedia: boolean
}

export function replayPrivacyFor(appEnvironment: string): ReplayPrivacy {
  const isProduction = appEnvironment === 'production'
  return { maskAllText: isProduction, blockAllMedia: isProduction }
}
